@if (entity() != null) {
  <div class="aside-body">
    <div class="thirdparty-infos">
      <h4 class="text-primary fw-bold my-1 title">
        {{ entity().reference }}
      </h4>
      <div class="audit-container mb-3">
        <core-informations-audited-entity [auditedEntity]="entity()">
        </core-informations-audited-entity>
      </div>
      @if (fileBlobUrl()) {
        <img class="aside-picture" [src]="fileBlobUrl()" />
      }
    </div>
    <div class="aside-tags">
      <a
        class="ui-tag badge rounded-pill bg-info"
        (click)="redirectToThirdParty(entity().thirdPartyId)"
        style="cursor: pointer"
      >
        {{ entity()?.thirdPartyName }}
      </a>
    </div>
    @if (deliveryAddressForm() != null) {
      <div class="my-2">
        <document-icon-address
          [addressFrom]="deliveryAddressForm().addressFrom"
          [docRole]="docRole.CustomerProject"
          class="me-1"
        ></document-icon-address>
        {{ deliveryAddressLabel() }}
      </div>
    }
  </div>
}
